import { gql } from 'apollo-angular';

const GET_SEARCH_PRODUCTS = gql`
  query SearchProducts($searchValue: String!) {
    search(
      searchCriteria: {
        searchValue: $searchValue
        limit: 0
        boostCriteria: [{ fieldName: "categoryId", fieldValue: 22 }]
        aggregationsOnly: true
        aggregationCriteria: {
          name: "categorizationscheme"
          subAggregation: { name: "category" }
        }
      }
    ) {
      type
      buckets {
        key
        count
        name
        aggregations {
          type
          buckets {
            key
            count
          }
        }
      }
    }
  }
`;

export default GET_SEARCH_PRODUCTS;
